import { useCallback } from 'react';
import { useDispatch, batch } from 'react-redux';

import { contactsApi } from '../services/contacts';
import { contactsV2Api } from '../services/contactsV2';
import { companiesApi } from '../services/companies';
import { networkAdminsApi } from '../services/networkAdmins';
import { networkAdminsApiV2 } from '../services/networkAdminV2';
import { hiresApi } from '../services/hires';
import { hiresV2Api } from '../services/hiresV2';
import { networkApi } from '../services/network';
import { networkV2Api } from '../services/networkV2';
import { userApi2 } from '../services/userV2';
import { apiKeysApiV2 } from '../services/apiKeysV2';
import { listsTreeApi } from '../services/listsTree';
import { customFieldsV2Api } from '../services/customFieldsV2';
import { talentAttractionApi } from '../services/talentAttraction';

export const useResetCache = () => {
  const dispatch = useDispatch();

  const apis = [
    contactsApi,
    contactsV2Api,
    companiesApi,
    networkAdminsApi,
    networkAdminsApiV2,
    hiresApi,
    hiresV2Api,
    networkApi,
    networkV2Api,
    userApi2,
    apiKeysApiV2,
    listsTreeApi,
    customFieldsV2Api,
    talentAttractionApi,
  ];

  const resetCache = useCallback(() => {
    batch(() => {
      apis.forEach((api) => dispatch(api.util.resetApiState()));
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return resetCache;
};
